import config from "@src/app-config.json";

export default class AppConfig {
  static env = process.env.NODE_ENV;

  static get(key) {
    const value = config[key];

    if (typeof value === "object" && !!value[AppConfig.env]) {
      return value[AppConfig.env];
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/classes/AppConfig.js